import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isSuperAdmin as isSuper, getAdminClients } from '@/redux/util';

export function useClientManagement({
	clients,
	adminSSOProfile,
	admins,
	currentClientID,
	auth0Token,
	setCurrentClientID,
	fetchPermissions,
}) {
	const location = useLocation();

	const setCurrentClientIDHelper = () => {
		const isSuperAdmin = isSuper();
		const adminClients = getAdminClients({
			admins,
			clients: Object.values(clients),
			adminSSOProfile,
			isSuperAdmin,
		});
		if (adminClients.length) {
			const { id } = adminClients[0];
			setCurrentClientID(id);
		}
	};

	useEffect(() => {
		const clientsArr = Object.values(clients);
		const isSuperAdmin = isSuper();
		const adminEmail = adminSSOProfile?.email;
		const adminPerms = admins[adminEmail];
		const userInfoLoaded = clientsArr.length && adminPerms && !isSuperAdmin && !currentClientID;

		if (!location.pathname.endsWith('agenda/') && !location.pathname.endsWith('agenda')) {
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
		}

		if (clientsArr.length && !currentClientID && isSuperAdmin) {
			const clientID = clientsArr[0].id;
			setCurrentClientID(clientID);
		}

		if (userInfoLoaded) {
			setCurrentClientIDHelper();
		} else if (adminEmail && !isSuperAdmin && !currentClientID) {
			setCurrentClientID(1);
		}

		fetchPermissions();
	}, [clients, adminSSOProfile, admins, currentClientID, auth0Token, location]);
}
